module.exports = __webpack_public_path__ + "img/logowescan.ea09bf97.jpeg";